module.exports = __webpack_public_path__ + "static/media/stclogo.f8b23bb3.png";